import { DatePipe } from '@angular/common';
import { Component, OnDestroy, OnInit, QueryList, ViewChildren } from '@angular/core';
import { Router } from '@angular/router';
import { ModalDismissReasons, NgbModal, NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { CustomPaggerService } from 'projects/Autofacets-Core/src/app/common-services/custom-pagger.service';
import { NgbdSortableHeader, SortEvent } from 'projects/Autofacets-Core/src/app/directives/sortable.directive';
import { Constant } from 'projects/Autofacets-Core/src/app/utils/constant';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { UserDataService } from 'src/app/DataServices/user-data.service';
import { UserDealersModel } from '../../business-entities/dealer-details.model';
import { DealerViewModel } from '../../business-entities/dealer-view-model';
import { MechanicList } from '../../business-entities/mechanicList-model';
import { SelectListItemViewModel } from '../../business-entities/select-list-item-view-model';
import { UserRoleMenu } from '../../business-entities/user-role-menu.model';
import { DealerSearchService } from '../../business-services/dealer-serach.service';
import { DealerBusinessService } from '../../business-services/dealer.service';
import { MechanicService } from '../../business-services/mechanic.service';
import * as Enums from './../../../../../Autofacets-Core/src/app/utils/enums';
import { AddMechanicComponent } from './add-mechanic/add-mechanic.component';
import { EditMechanicComponent } from './edit-mechanic/edit-mechanic.component';
import { StatusViewModel } from '../../business-entities/status-view-model';
import { DashboardService } from '../../business-services/dashboard.service';
import { Features } from '../../business-entities/user-role-view-model';
import { SecureStorage } from 'projects/Autofacets-Core/src/app/common-services/SecureStorage.service';
import { CurrentLanguage } from 'projects/Autofacets-Core/src/app/common-services/current-language.service';
import { DMSSyncFailedLogRequestModel } from '../../business-entities/dmssyncfailedlog-request-model';
import { TranslateService } from '@ngx-translate/core';
import { DMSSyncFailedlogService } from '../../business-services/dms-sync-failed-log.service';
import { NgInfoModalContent } from 'projects/Autofacets-Core/src/app/shared/info-modal.component';
import { ToastrService } from 'ngx-toastr';
import { NgbdModalContent } from 'projects/Autofacets-Core/src/app/shared/delete-modal.component';
@Component({
  selector: 'app-mechanic',
  templateUrl: './mechanic.component.html'
})
export class MechanicComponent implements OnInit, OnDestroy {
  mechanicList: MechanicList[];
  total$: Observable<number>;
  selectedDealer:string;
  paginationSub: Subscription;
  dealerList: Array<SelectListItemViewModel>;
  dealers: DealerViewModel[] = [];
  dealerId: string = '';
  id: string = '0';
  userRoleRightsDetails: UserRoleMenu;
  StatusList: StatusViewModel[] = [];
  selectedStatus: number;
  areCodesHidden = false;
  isOLB : boolean = false;
  popupCloseResult = false;
  subscription : Subscription;
  features: Features[] = [];
  dmsLogRequestModel: DMSSyncFailedLogRequestModel =
    {
      startRecordNumber: 0,
      pageSize: 25,
      sortColumn: '',
      sortDirection: '',
      moduleId: Enums.ModuleNames.Mechanic,
      logDate: '',
      referenceId: 0,
      referenceName: ''
    };

  @ViewChildren(NgbdSortableHeader) headers: QueryList<NgbdSortableHeader>;
  constructor(
    public mechanicService: MechanicService,
    public dealerBusinessService: DealerBusinessService,
    private spinner: NgxSpinnerService,
    public pService: CustomPaggerService,
    private datePipe: DatePipe,
    private userService: UserDataService,
    private modalService: NgbModal,
    private dashboardService: DashboardService,
    private secureStorage: SecureStorage,
    private currentLanguageService: CurrentLanguage,
    private translate: TranslateService,
    private dmsService: DMSSyncFailedlogService,
    private toaster: ToastrService,
    config: NgbModalConfig
  ) {
    this.pService.pageSize = 10;
    this.pService.searchby = ['name', 'dealerName', 'employeeNo', 'adEmail'];
    this.pService.searchTerm = '';
    config.backdrop = 'static';
    config.keyboard = false;
  }

  onSort({ column, direction }: SortEvent) {
    this.headers.forEach(header => {
      if (header.sortable !== column) {
        header.direction = '';
      }
    });

    this.pService.sortColumn = column;
    this.pService.sortDirection = direction;
  }

  async ngOnInit(): Promise<void> {
    this.areCodesHidden = localStorage.getItem('Theme') === 'mg';
    this.userRoleRightsDetails = (this.userService.currentUserValue.userRoleMenuDetails as any[]).find(menu => menu.moduleId === Enums.ModuleNames.Mechanic);
    this.pService.dataSource = [];
    this.checkId();
    this.getUserDealers();
    this.selectedStatus = Enums.StatusCode.Active;
    this.dealerId = this.userService.currentUserValue.defaultDealerId ?? '';
    this.selectedDealer = this.userService.currentUserValue.defaultDealerId ?? '';
    this.GetMechanicList(this.dealerId, this.selectedStatus);
    this.StatusList = this.dashboardService.getStatusList();
    await this.getFeatures();
  }

  async getFeatures() {
    this.features = this.secureStorage.getKeyData('feature');
    if (this.features == null || this.features == undefined) {
      this.subscription = this.currentLanguageService.featureList.subscribe((res) => {
        this.features = res;
        if (this.features?.length > 0) {
          this.setFetureData();
        }
      })
    }
    else {
      this.setFetureData();
    }
  }

  setFetureData() {
    this.isOLB = this.features.find(x => x.featureCode === Enums.FeatureCode.OLB)?.isActive;
  }

  onDealerSelected(dealerId: string) {
    this.dealerId =  dealerId ?? '' ;
    let status = 0;
    if (this.selectedStatus != undefined) {
      status = this.selectedStatus;
    }
    this.GetMechanicList(this.dealerId, status);
  }
  async getUserDealers() {
    await this.dealerBusinessService.getUserDealersDropdown().then((response) => {
      this.dealerList = this.mapdealer(response.userDealersModel);
      this.mechanicService.dealerList = this.dealerList;
      if(this.dealerList.length===1){
        this.selectedDealer = this.dealerList[0].value;
      }
    })
  }

  mapdealer(array: UserDealersModel[]) {
    let supperArray = [];
    if (array && array.length > 0) {

      array.forEach(element=>{
        let single = Object();
        single.value = element.dealerId
        single.text = element.dealerName
        single.locationCode = element.locationCode
        supperArray.push(single);
      })
    }
    return supperArray;
  }

  checkId() {
    this.mechanicService.isEdit = false;
  }

  onEdit(mechanic: any) {
    this.mechanicService.dealerId = mechanic.dealerId;
    this.mechanicService.mechanicId = mechanic.id;
    this.mechanicService.mechanicName = mechanic.name;
    this.mechanicService.isConsiderCustomerWaitingSlots$.next(null);
    const modalref = this.modalService.open(EditMechanicComponent, { size: 'lg', windowClass: 'EditPopup' });
    modalref.result.then((response) => {
      if (response.success) {
        this.ngOnInit();
      }
    });
  }
  
  StatusChange(status) {
    if (status == undefined) {
      status = Enums.StatusCode.All;
    }
    this.GetMechanicList(this.dealerId, status);
  }
  GetMechanicList(id: string, status: number) {
    this.spinner.show();
    this.mechanicService.GetMechanicList(id, status).then((response) => {
      if (response.responseCode == Constant.SuccessResponseCode) {
        this.pService.dataSource = response.responseObject;
        this.paginationSub = this.pService.dealers$.subscribe((result: any) => {
          this.mechanicList = this.MechanicDataMapper(result);
        });
        this.total$ = this.pService.total$;
        this.spinner.hide();
      }
      else if (response.responseObject && response.responseObject.errorCount > 0) {
        if (response.responseObject.result &&
          response.responseObject.result.errorCode === Enums.ErrorCodes.MechanicCode) {
          this.spinner.hide();
        }
      }
      this.spinner.hide();
    });
  }

  onAdd() {
    const modalref = this.modalService.open(AddMechanicComponent, { size: 'lg', windowClass: 'EditPopup' });
    modalref.result.then((response) => {
      if (response.success) {
        this.ngOnInit();
      }
    });
  }

  private MechanicDataMapper(List: any) {
    let supperArray = [];
    if (List && List.length > 0) {

      for (let index = 0; index < List.length; index++) {
        const element = List[index];

        let single = Object();
        single.rowNumber = this.currentPageNumber(index);
        single.id = element.id;
        single.name = element.name;
        single.employeeNo = element.employeeNo;
        single.adEmail = element.adEmail;
        single.isActive = element.isActive;
        single.createdBy = element.createdBy;
        single.updatedBy = element.updatedBy;
        single.dealerId = element.dealerId;
        single.dealerName = element.dealerName;
        single.createdDate = element.createdDate;
        single.adZIdent = element.adZIdent;
        single.functionCode = element.functionCode;
        single.functionCodeDescription = element.functionCodeDescription;
        single.locationCode = element.locationCode;
        single.locationName = element.locationName;
        single.dmsSyncDate = element.dmsSyncDate;
        single.dmsSyncStatus = element.dmsSyncStatus;
        single.updatedDate = element.updatedDate ? this.datePipe.transform(new Date(element.updatedDate), 'dd/MM/yyyy').toString() : null;
        supperArray.push(single);
      }
    }
    return supperArray;
  }

  ngOnDestroy(): void {
    if (this.paginationSub) {
      this.paginationSub.unsubscribe();
    }
    this.pService.dealers$ = new BehaviorSubject<any[]>([]);
    this.pService.total$ = new BehaviorSubject<number>(0);
    this.dashboardService.isFromDashboard = false;
  }

  /**
 * Method to generate auto row number based on per page size
 * @param cIndex
 */
  private currentPageNumber(cIndex: number): number {
    let rtPageNumber = 0;
    if (this.pService.page === 1) {
      rtPageNumber = cIndex + 1;
    }
    else if (this.pService.page > 1) {
      rtPageNumber = Number.parseInt(`${(this.pService.pageSize * (this.pService.page - 1))}`) + (cIndex + 1);
    }

    return rtPageNumber;
  }
  onSyncToDms(mechanicId) {
    let modelHeadermsg = this.translate.instant("lblSyncToOLB");
    let modelBodymsg = this.translate.instant("lblSureToSyncOLB");
    let errorMsg = this.translate.instant('lblErrormsg');
    const modalRef = this.modalService.open(NgbdModalContent);
    modalRef.componentInstance.modelHeader = modelHeadermsg;
    modalRef.componentInstance.modelBody = modelBodymsg;
    modalRef.result.then((_result) => {
      // This is intentional
    }, (reason) => {
      this.popupCloseResult = this.getDismissDeleteReason(reason);
      if (this.popupCloseResult) {
        this.spinner.show();
        this.mechanicService.ResyncMechanic(mechanicId).then((response) => {
          this.spinner.hide();
          if (response.responseObject) {
            let successMsg = this.translate.instant('lblSyncSuccessOLB')
            this.toaster.success(successMsg);
            let status = 0;
            if (this.selectedStatus != undefined) {
              status = this.selectedStatus;
            }
            this.GetMechanicList(this.dealerId, status);
          } else {
            this.spinner.hide();
            this.toaster.error(errorMsg);
          }
        });
      }
    });
  }

  viewException(employeeNo: string) {
    this.dmsLogRequestModel.referenceName = employeeNo;
    this.spinner.show();
    let errorMsg = this.translate.instant('lblNoErrorDetails');
    this.dmsService.GetDmsSyncFailedLog(this.dmsLogRequestModel).then((response) => {
      if (response.responseCode == Constant.SuccessResponseCode) {
        this.spinner.hide();
        if (response.responseObject.length > 0) {
          let ex = response.responseObject[0].exceptionMessage;

          let modelHeadermsg = this.translate.instant("lblException");
          const modalRef = this.modalService.open(NgInfoModalContent);
          modalRef.componentInstance.modelHeader = modelHeadermsg;
          modalRef.componentInstance.modelBody = ex;
          modalRef.result.then((_result) => {
          }, (reason) => {
            this.popupCloseResult = this.getDismissDeleteReason(reason);
          });
        } else {
          this.toaster.error(errorMsg);
        }
      }
      else if (response.responseObject && response.responseObject.errorCount > 0) {
        if (response.responseObject.result &&
          response.responseObject.result.errorCode === Enums.ErrorCodes.MechanicCode) {
          this.spinner.hide();
        }
      }
      this.spinner.hide();
    });
  }

  private getDismissDeleteReason(reason: any): boolean {
    if (reason === ModalDismissReasons.ESC) {
      return false;
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return false;
    } else {
      return reason;
    }
  }
}
